<template>
  <section class="container">
    <!-- <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="routerTo(`/product-add`)">新增</el-button>
    </div> -->

    <el-form label-width="100px">
      <el-form-item label="标题">
        <!-- <el-input v-model="editObject.product_title"/> -->
        <span v-text="editObject.product_title" />
      </el-form-item>
      <el-form-item label="副标题">
        <!-- <el-input v-model="editObject.product_son_title"/> -->
        <span v-text="editObject.product_son_title" />
      </el-form-item>
      <el-form-item label="英文标题">
        <!-- <el-input v-model="editObject.product_title"/> -->
        <span v-text="editObject.product_english_title" />
      </el-form-item>
      <el-form-item label="英文副标题">
        <!-- <el-input v-model="editObject.product_son_title"/> -->
        <span v-text="editObject.product_english_son_title" />
      </el-form-item>
      <el-form-item label="价格">
        <!-- <el-input v-model="editObject.product_now_price"/> -->
        <span v-text="editObject.product_son_title" />
      </el-form-item>
      <el-form-item label="原价">
        <!-- <el-input v-model="editObject.product_price"/> -->
        <span v-text="editObject.product_price" />
      </el-form-item>
      <el-form-item label="权重">
        <!-- <el-input v-model="editObject.product_sort"/> -->
        <span v-text="editObject.product_sort" />
      </el-form-item>
      <el-form-item label="封面">
        <img
          v-if="editObject.product_icon"
          :src="qiniuDomain + editObject.product_icon"
          class="avatar">
      </el-form-item>
      <el-form-item label="banner">
        <img
          v-if="editObject.product_banner"
          :src="qiniuDomain + editObject.product_banner"
          class="banner-img">
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  addProduct, editProduct, productDetail,
} from '@/api/product'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        product_title: '',
        product_son_title: '',
        product_english_title: '',
        product_english_son_title: '',
        product_icon: '',
        product_sort: '',
        product_banner: '',
        product_price: '',
        product_now_price: '',
        uuid: '',
      },
    };
  },


  created() {
    this.network().getQiniuInfo()
    this.network().productDetail()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    uploadBannerSuccess(res) {
      this.editObject.product_banner = res.hash
    },
    uploadSuccess(res) {
      this.editObject.product_icon = res.hash
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        productDetail: async () => {
          const { status, data } = await productDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject = data
          }
        },
        addProduct: async () => {
          const { status } = await addProduct(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().productList()
          }
        },
        editProduct: async () => {
          const { status } = await editProduct(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().productList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/product/detail.vue